import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import template from 'url-template';

import { get, isEmpty, capitalize, findIndex } from 'lodash';

import MaterialTable from 'material-table';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import ActionBar from '../../components/ActionBar';
import ActionBarItem from '../../components/ActionBarItem';
import EsmsPage from '../../components/EsmsPage';

import * as DeviceActions from '../../actions/deviceActions';
import * as InventoryActions from '../../actions/inventoryActions';
import * as ProfileActions from '../../actions/profileActions';
import * as ProfileObjectActions from '../../actions/profileObjectActions';

import classes from './UseExistingBacnetProfilePage.module.css';

const InventoryUrl= template.parse('/iothub/basagents/manage/inventory/bacnet{?basAgent,company}');

class UseExistingBacnetProfilePage extends Component {
    state = {
        basType:       '',
        profileId:     '',
        profileName:   '',
        selectProfile: ''
    };

    componentDidMount() {
        const {
            companyInfo,
            fetchProfiles,
            selectedAgent
        } = this.props;

        fetchProfiles(companyInfo.companyId);

        this.setState({
            basType: get(selectedAgent, 'driverConfiguration[0].basType', '').toLowerCase()
        });
    }

    handleChange = async event => {
        const { fetchProfileObjects } = this.props;
        const { value } = event.target;

        this.setState({
            profileId:     get(value, 'id', ''),
            profileName:   get(value, 'name', ''),
            selectProfile: value
        });

        await fetchProfileObjects(value.id);
    }

    handleRedirectToBasInventory = () => {
        const {
            bacnetInventory,
            companyInfo,
            history,
            resetProfileObjects,
            selectedAgent,
            selectedDevices,
            setBacnetInventory
        } = this.props;

        selectedDevices.forEach(device => {
            const deviceIndex = findIndex(bacnetInventory, item => item.id === device.id);

            device.profileName = this.state.profileName;
            device.profileId = this.state.profileId;
            device.tableData.checked = false;

            bacnetInventory[deviceIndex] = {...device};
        });

        setBacnetInventory(bacnetInventory);

        resetProfileObjects();

        history.push(InventoryUrl.expand({
            company:  companyInfo.companyId,
            basAgent: selectedAgent.id
        }));
    }

    render() {
        const { companyInfo, profiles, profileObjects } = this.props;
        const { basType, selectProfile } = this.state;

        return (
            <EsmsPage
                child="Use Existing Profile"
                parents={[
                    companyInfo.companyName,
                    'BAS Agents',
                    'Profiles'
                ]}
                title="Use Existing Profile"
            >
                <FormControl>
                    <InputLabel
                        htmlFor="profile"
                        classes={{
                            focused: classes.labelFocused,
                            root:    classes.label
                        }}
                    >
                        Select Profile
                    </InputLabel>
                    <Select
                        inputProps={{
                            classes: {
                                root: classes.input
                            },
                            id: 'profile'
                        }}
                        MenuProps={{
                            MenuListProps: {
                                className: classes.select
                            }
                        }}
                        name="profiles"
                        id="profiles"
                        onChange={this.handleChange}
                        value={selectProfile}
                    >
                        {
                            profiles
                                .filter(profile => profile.basType.toLowerCase() === basType)
                                .map(profile => (
                                    <MenuItem
                                        key={profile.id}
                                        value={profile}
                                    >
                                        <span>{profile.name}</span>
                                    </MenuItem>
                                ))
                        }
                    </Select>
                </FormControl>
                <ActionBar>
                    <ActionBarItem
                        disabled={!profileObjects.length}
                        onClick={this.handleRedirectToBasInventory}
                        type="save"
                    >
                        Assign
                    </ActionBarItem>
                </ActionBar>
                <div className={classes.DeviceObjectTable}>
                    <MaterialTable
                        options={{
                            paging:    false,
                            showTitle: false,
                            search:    false,
                            selection: false,
                            toolbar:   false
                        }}
                        columns={[
                            { title: 'Name', field: 'name' },
                            {
                                title:  'Data Type',
                                field:  'dataType',
                                render: rowData => !isEmpty(rowData.dataType) ? capitalize(rowData.dataType) : ''
                            },
                            {
                                title:  'Trend Interval',
                                field:  'sampleInterval',
                                render: rowData => rowData.changeOfValue ? 'CoV' : rowData.sampleInterval
                            },
                            {
                                title: 'Object Type',
                                field: 'objectType'
                            },
                            { title: 'Object Instance', field: 'ObjectInstance'},
                            { title: 'Object Value', field: 'ObjectValue'}
                        ]}
                        data={profileObjects}
                    />
                </div>
            </EsmsPage>
        );
    }
}

const mapStateToProps = ({ basAgent, ...state }) => {
    const { basAgents, selectedAgentId } = basAgent;
    const selectedAgent = basAgents[selectedAgentId];
    return {
        bacnetInventory: state.inventory.bacnetInventory,
        companyInfo:     state.companyInfo,
        currentScopes:   state.core.currentScopes,
        devices:         state.device.devices,
        profiles:        state.profile.profiles,
        profileObjects:  state.profileObjects.profileObjects,
        selectedAgent,
        selectedDevices: state.device.selectedDevices
    };
};

const mapDispatchToProps = {
    ...DeviceActions,
    ...InventoryActions,
    ...ProfileActions,
    ...ProfileObjectActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UseExistingBacnetProfilePage));
